export default "__VITE_ASSET__CLALsiBb__"